<div *ngIf="chart.data && $any(chart).data[0]" [ngStyle]="chartStyle" [ngClass]="[$any(chart).data[0].type === 'pie' ? 'pie-chart' : '', (featureConst | isFeatureAccessible:accessStatus) ? '' : 'blur' ]" style="position: static; margin-left: -30px"
[attr.data-cy]='e2eName'
>
    <plotly-plot
        appChartLegendGapFix
        [data]="$any(chart).data"
        [layout]="chart.layout"
        [config]="currentChartConfig"
    ></plotly-plot>
</div>
